import UserVerifyForm from "./UserVerifyFormContainer";

export default UserVerifyForm;
